require('./hireOpenYoungInterveners.scss');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @actions
const HireOpenYoungIntervenersActions = require('actions/hireOpenYoungInterveners');
// @ utility
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ components
const IntervenerRow = require('./hireOpenYoungIntervenerRow/hireOpenYoungIntervenerRow');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ constants
//TODO check this condition
//const { ACCOUNT_INTERVENTION_OWNER_CODE } = require('constants/index');

class HireOpenYoungInterveners extends React.Component {
    componentDidMount() {
        const {
            accountId,
            immHireOpenYoungInterveners,
            requestAccountInterveners,
        } = this.props;

        if (!immHireOpenYoungInterveners.get('fetchSuccess')) {
            requestAccountInterveners(accountId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { accountId, requestAccountInterveners } = this.props;
        const { accountId: nextAccountId } = nextProps;
        
        if (accountId !== nextAccountId) {
            requestAccountInterveners(nextAccountId);
        }
    }

    buildIntervenersRows () {
        const {
            immHireOpenYoungInterveners,
            changeIntervenerRelationship,
            excludeIntervener
        } = this.props;
        const onlyOneOwnerLeft = immHireOpenYoungInterveners.get('list').size === 1;

        return immHireOpenYoungInterveners.get('list').map((intervener, index) =>
            (
                <IntervenerRow
                    id={index}
                    intervenerName={intervener.get('name')}
                    key={index}
                    onExclude={excludeIntervener}
                    onTypeChange={changeIntervenerRelationship}
                    relationship={intervener.get('relationship')}
                    showError={intervener.get('error')}
                    showRemoveButton={!onlyOneOwnerLeft}
                />
            )
        );
    }

    buildRestoreDefaultIntervenersLink() {
        const { immHireOpenYoungInterveners, resetAccountInterveners } = this.props; 
        const restoreValuesLabel = formatText('hireOpenYoungInterveners-hireOpenYoungInterveners_restoreValues');

        let intervenersLink;

        if (immHireOpenYoungInterveners.get('isDirty') && immHireOpenYoungInterveners.get('list')) {
            intervenersLink = (
                <OKButton
                    modifier="ghost"
                    onClick={resetAccountInterveners}
                >
                    {restoreValuesLabel}
                </OKButton>
            );
        }

        return intervenersLink;
    }

    render () {
        const { holderName, immHireOpenYoungInterveners } = this.props;
        const restoreDefaultLink = this.buildRestoreDefaultIntervenersLink();
        let content = <LoadingSection />;

        if (!immHireOpenYoungInterveners.get('isLoading') && immHireOpenYoungInterveners.get('fetchSuccess')) {
            const interveners = this.buildIntervenersRows();
            
            content = (
                <div className="open-young-interveners">
                    <h3 className="row open-young-interveners__subheader">
                        <FormattedText
                            className="col-xs-12"
                            value="hireOpenYoungInterveners-hireOpenYoungInterveners_interveners"
                        />
                    </h3>
                    <div className="open-young-interveners__titular-section">
                        <p className="open-young-interveners__intervener-name">{holderName}</p>
                        <FormattedText
                            className="open-young-interveners__sublabel"
                            value="hireOpenYoungInterveners-hireOpenYoungInterveners_titular"
                        />
                    </div>
                    {interveners}
                    {restoreDefaultLink}
                </div>
            );
        }

        return content;
    }
}

HireOpenYoungInterveners.propTypes = {
    accountId: PropTypes.string.isRequired,
    changeIntervenerRelationship: PropTypes.func.isRequired,
    excludeIntervener: PropTypes.func.isRequired,
    holderName: PropTypes.string.isRequired,
    immHireOpenYoungInterveners: PropTypes.object.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired,
    resetAccountInterveners: PropTypes.func.isRequired,
}


module.exports.constructor = HireOpenYoungInterveners;
module.exports.HireOpenYoungInterveners = connect(null,
    {
        changeIntervenerRelationship: HireOpenYoungIntervenersActions.changeIntervenerRelationship,
        excludeIntervener: HireOpenYoungIntervenersActions.excludeIntervener,
        requestAccountInterveners: HireOpenYoungIntervenersActions.requestAccountInterveners,
        resetAccountInterveners: HireOpenYoungIntervenersActions.resetAccountInterveners,
    }
)(HireOpenYoungInterveners);
